import './rental.js'
import { appearOnIntersect } from './observer-appear.js'

//appear on intersect and load images
appearOnIntersect()
